import en from "./lang/en.js";
import ru from "./lang/ru.js";
import ua from "./lang/ua.js";

const langIndex = {
    en,
    ru,
    ua,
};

export default langIndex;
